import React from 'react';
import { Grid, Dropdown, Input, Button } from 'semantic-ui-react';
import Loading from '../../loading';
import Server from '../../../functions/server'
import $ from "jquery";
import CircularProgress from '@material-ui/core/CircularProgress';

class EditBrand extends React.Component {

  state = {
    load: false,
    message: '',
    value: ''
  }

  componentDidMount() {
    this.getBrand();
    this.set();
  }

  set() {
    this.props.data.map((z) => {
      if (z.id == this.props.editid) {
        let mrp = Number(z.mrp);
        let dnp = Number(z.dnp);
        let tax = Number(this.props.tax);
        let taxablePrice = mrp + (mrp * (tax/100));
        taxablePrice = taxablePrice.toFixed(2);
        let taxableDnp = dnp + (dnp * (tax/100));
        taxableDnp = taxableDnp.toFixed(2);
        this.setState({
          value: z.brand_id,
          value1: z.brand,
          part_code: z.part_code,
          dnp: taxableDnp,
          mrp: taxablePrice,
          point: z.point,
          life: z.life,
          weight: z.weight,
          min_order_qty: z.min_order_qty,
          aliasId: z.alias_id
        });
      }
    })
  }

  getBrand() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Brands!!!'
    });
    $.ajax({
      type: 'POST',
      url: Server() + 'addmenu/branddetails/getallbrands.php',
      success: function(data)
      {
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setBrand(data);
        } catch (e) {
          console.log(e);
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  setBrand(data) {
    let context = this;
    var x = [];
    data.map((y) => {
      let name = y.id + ' -> ' + y.brand_name;
      x.push({key: name, text: name, value: y.id});
    });
    try {
      context.setState({
        brandOption: x,
      });
    } catch (e) {

    }
  }

  brand = (f, { value }) => {
    this.setState({
      value: value
    });
  }

  onChange = (type) => (e, {value}) => {
    this.setState({
      [type]: value
    })
  }

  add() {
    let context = this;
    let value = this.state.value;
    let partCode = this.state.part_code;
    let id = this.props.editid;
    let point = this.state.point;
    let life = this.state.life;
    let weight = this.state.weight;
    let min_order_qty = this.state.min_order_qty;
    let aliasId = this.state.aliasId;
    let partno = this.props.partno;
    if (value == '' || value == null || value == undefined) {
      this.setState({ error: 'Select the Brand!!!' });
      return;
    }
    if (partCode == '' || partCode == null || partCode == undefined) {
      this.setState({ error: 'Enter the Part Code!!!' });
      return;
    }

    if (point == '' || point == null || point == undefined) {
      this.setState({ error: 'Enter the Point!!!' });
      return;
    }
    if (life == '' || life == null || life == undefined) {
      this.setState({ error: 'Enter the Life!!!' });
      return;
    }
    if (weight == '' || weight == null || weight == undefined) {
      this.setState({ error: 'Enter the Weight!!!' });
      return;
    }
    if (min_order_qty == '' || min_order_qty == null || min_order_qty == undefined) {
      this.setState({ error: 'Enter the Minmum Order Quality!!!' });
      return;
    }
    let data1 = { 'editId': id, 'brand': value, 'part_code': partCode, 'point': point,
                  'life':life, 'weight': weight, 'min_order_qty': min_order_qty,
                  'aliasId': aliasId, 'partno': partno  };
    context.setState({ load: true, message: 'Adding Brand!!!' });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/editbrand.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        })
        if (data == 1) {
          context.props.update();
        }
      },
      error: function(e)
      {
        context.setState({
          load: false,
        })
        console.log(e);
      }
    })
  }

  render() {
    const { load, message, value, value1 } = this.state;
    return (
      <div>
        <Loading load={load} message={message} />
        <Grid>
          <Grid.Column mobil={16} tablet={16} computer={8}>
            Brand<br/>
            <b style={{fontSize: 15}}>{value+'->'+value1}</b>
            <Dropdown
              id="brand" style={{display: 'none'}} onChange={this.brand} fluid focus
              search selection options={this.state.brandOption}
              value={value} />
          </Grid.Column>
          <Grid.Column mobil={16} tablet={16} computer={8}>
            Part Code<br/>
            <Input focus value={this.state.part_code} disabled 
                onChange={this.onChange('part_code')}
                style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>

          <Grid.Column mobil={16} tablet={16} computer={8}>
            Point<br/>
            <Input focus value={this.state.point}
                onChange={this.onChange('point')}
                style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobil={16} tablet={16} computer={8}>
            Life<br/>
            <Input focus value={this.state.life}
                onChange={this.onChange('life')}
                style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobil={16} tablet={16} computer={8}>
            Weight<br/>
            <Input focus value={this.state.weight}
                onChange={this.onChange('weight')}
                style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobil={16} tablet={16} computer={8}>
            Minmum Order Quality<br/>
            <Input focus value={this.state.min_order_qty}
                onChange={this.onChange('min_order_qty')}
                style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>

          <Grid.Column mobil={16} tablet={16} computer={8} style={{display: 'none'}}>
            DNP<br/>
            <Input focus value={this.state.dnp}
                onChange={this.onChange('dnp')}
                style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobil={16} tablet={16} computer={8} style={{display: 'none'}}>
            MRP<br/>
            <Input focus value={this.state.mrp}
                onChange={this.onChange('mrp')}
                style={{ borderColor: '#5A9CBB' }}
                fluid />
          </Grid.Column>
          <Grid.Column mobil={16} tablet={16} computer={16}>
            <div style={{color: 'red'}}><center>{this.state.error}</center></div>
          </Grid.Column>
          <Grid.Column mobil={16} tablet={16} computer={8}>
            <Button fluid onClick={ () => { this.props.handleClose(); } }>Cancel</Button>
          </Grid.Column>
          <Grid.Column mobil={16} tablet={16} computer={8}>
            {load ?
              (<div><center><CircularProgress size={18} color='secoundary' /></center></div>)
             :
              (<div><Button fluid onClick={this.add.bind(this)}>Save</Button></div>)
            }
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default EditBrand;
